module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.8028/img/elite-tier-icon-bordered.svg"